import React, { useState, Fragment } from "react";
import "../style.scss";
import EnquiryForms from "../Components/Slide.js"; // ← use standalone form, no sliding panel

const Plc = () => {
    const [showList1, setShowList1] = useState("");
    const [showList2, setShowList2] = useState("");
    const [showList3, setShowList3] = useState("");
    const [showList4, setShowList4] = useState("");
    const [showList5, setShowList5] = useState("");
    const [showList6, setShowList6] = useState("");
    const [showList7, setShowList7] = useState("");
    const [showList8, setShowList8] = useState("");
    const toggleList = (listNumber) => {
        if (listNumber === 1) {
            setShowList1(!showList1);
            setShowList2(false);
            setShowList3(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 2) {
            setShowList2(!showList2);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 3) {
            setShowList3(!showList3);
            setShowList2(false);
            setShowList1(false);
            setShowList4(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 4) {
            setShowList4(!showList4);
            setShowList1(false);
            setShowList3(false);
            setShowList2(false);
            setShowList5(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 5) {
            setShowList5(!showList5);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList6(false);
            setShowList7(false);
            setShowList8(false);
        } else if (listNumber === 6) {
            setShowList6(!showList6);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList7(false);
            setShowList8(false);
            setShowList5(false);
        } else if (listNumber === 7) {
            setShowList7(!showList7);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList5(false);
            setShowList6(false);
            setShowList8(false);
        } else if (listNumber === 8) {
            setShowList8(!showList8);
            setShowList1(false);
            setShowList3(false);
            setShowList4(false);
            setShowList2(false);
            setShowList5(false);
            setShowList7(false);
            setShowList6(false);
        }
    };
    return (
        <Fragment>
            {/* <div className="botam-navbar">
        <p style="margin-left: 15px; color: #fff">To avail the weekly free training offer <br />Sign up Now.</p>
        <a href="#corseform" className="active">To know course fee.</a>
        <a href="#corseform" className="active">Know More</a>
      </div> */}

            <div id="main-wrapper">
                <div className="site-wrapper-reveal">
                    <div
                        className="about-banner-wrap vision-space bg-img responsive_banner_courses"

                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 section-space--pt_100">
                                    <h1 className="mobile-page-heading">PLC
                                    </h1>
                                    <p className="mobile-page-paragraph">
                                        (PLCs) are one of the most useful technologies in the industries for automation

                                    </p>
                                </div>
                                <div className="col-lg-2"></div>
                                <div className="col-lg-4">
                                    <div
                                        className="form-container mx-auto mx-xl-0 ml-xl-auto border"
                                        id="corseform"
                                        style={{
                                            marginTop: "20px",
                                            backgroundColor: "white",
                                            alignItems: "center",
                                            marginLeft: "100px",
                                        }}
                                    >
                                                           <EnquiryForms  courseName="PLC"  showCategory={false} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        PLC
                    </li>
                </ol>
            </nav>

            <div className="vision-overview  " style={{ marginTop: "-180px" }}>
                <div className="container">
                    <div className="section-title-wrap text-center">
                        <br />
                        <br />
                        <h3 className="heading">
                            <span
                                className="text-color-primary"
                                style={{ fontSize: "25px", color: "#ffc107" }}
                            >
                                {" "}
                                Training Highlights
                            </span>
                        </h3>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Instructor Led Training</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Weekly Doubt clearing Session</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">Lifetime Assistance for Revision</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">
                                        Lifetime Login Access to Student Dashboard
                                    </h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">World-Wide Valid Certification</h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="item-container d-flex align-items-center">
                                <div className="image-container">
                                    <img
                                        src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
                                        className="lazy-load"
                                    />
                                </div>
                                <div className="content-container">
                                    <h3 className="title">
                                        Study Material, Assignments and Projects
                                    </h3>
                                    <p className="description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br /> <br />
                    <div
                        className="section-title-wrap text-center"
                        style={{ marginTop: "-140px" }}
                    >
                        <h3 className="heading">
                            <span
                                className="text-color-primary"
                                style={{ fontSize: "30px", color: "#ffc107" }}
                            >
                                {" "}
                                Course Highlights
                            </span>
                        </h3>
                    </div>
                    <div className="row">
                        <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
                            {/* <div className="dashed-border">
                                <img
                                    className="d-block d-lg-none"
                                    src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
                                />
                                <img
                                    className="d-none d-lg-block"
                                    src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
                                    width={1000}
                                />
                            </div> */}
                            <div className="d-flex flex-column  align-items-start flex-lg-row justify-content-lg-center">
                                <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
                                    <div
                                        className="number-container"
                                        
                                    >
                                        <div className="number-box">1</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">Navigating the User Interface




                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">2</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">
                                            Program Input and Output
                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">3</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">
                                            Multiple Inputs and Output



                                        </p>
                                    </div>
                                </div>
                                <div className="item-container d-flex flex-lg-column align-items-center">
                                    <div className="number-container">
                                        <div className="number-box">4</div>
                                        <div className="arrow-container">
                                            <div className="arrow arrow-left"></div>
                                            <div className="arrow arrow-right"></div>
                                        </div>
                                    </div>
                                    <div className="content-container">
                                        <p className="activity">Timer and Counter Instructions</p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "-120px" }}>
                        <div className="col-lg-12">
                            <br />
                            <br />
                            {/* <!-- <h3 className="heading" style="font-size: 21px;">Course Overview</h3> --> */}
                            <h3 className="heading">
                                <span
                                    className="text-color-primary"
                                    style={{ fontSize: "30px", color: "#ffc107" }}
                                >
                                    {" "}
                                    Course Overview
                                </span>
                            </h3>
                            <br />
                            <br />
                            <div>
                                <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: 'justify' }}>
                                    Programmable logic controllers (PLCs) are one of the most useful technologies in the industries for automation. They are industrial computer systems that are used to control the electro-mechanical processes in various industries like manufacturing, plants, etc. CAD DESK provides classroom training for PLC, through which students get an opportunity to learn from our expert trainers; who give a great emphasis on delivering the best quality training to each of its learners.

                                    PLCs are available in varied sizes and forms. PLC provides the ability to reprogram the process at very little cost. Programmable logic controllers are flexible and depending on the input and output, it records the data, such as machine productivity or operating temperature. CAD DESK provides the best quality training to its students in the field of CAD, CAM & CAE. Moreover, while taking the coaching classes, students are encouraged to do Internship and also gets an opportunity to go for industrial visits as well.

                                    CAD DESK gives Placement assistance to their students through which students get an opportunity to work in various companies in India. While doing CAD coaching classes, students get many other facilities including books, e-books, tutorials, and projects along with their student panel. CAD DESK students also get an additional benefit of a transfer facility through which they can move to any of our CAD franchise centers in India; even if they are enrolled at CAD DESK Jaipur or at any other center. After finishing the software training, CAD DESK students get a PLC certificate of course completion that provides industry recognition to the students, which will enhance their career path. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                }}
            >
                <div style={{ flex: 1 }}>
                    <h3 className="heading">
                        <span
                            className="text-color-primary responsive_course_content"

                        >
                            {" "}
                            Course Contents
                        </span>
                    </h3>

                    <div classNameName="row">
                        {" "}
                        <div className="responsive_courese_image_container_mobile_view">
                            <img
                                src="img/PLC-1.webp"
                                alt="Course Image"
                                className="responsive_course_image_mobile_view"
                            />
                        </div>

                        <div
                            className="responsive_introduction_container"
                        >
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(1)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList1 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Introduction to Industrial automation
                            </button>
                            {showList1 && (
                                <ul>
                                    <li> Application of Industrial automation
                                    </li>
                                    <li>AutoCAD Electrical Interface</li>
                                    <li>The need of automation in Industries.

                                    </li>
                                    <li>Introduction to programmable logic controller

                                    </li>
                                    <li>Block diagram of programmable logic controller

                                    </li>

                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(2)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList2 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Type of Plc
                            </button>
                            {showList2 && (
                                <ul>
                                    <li>Compact
                                    </li>
                                    <li>Modular
                                    </li>
                                    <li>Rack type
                                    </li>


                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(3)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList3 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Architecture of PLC
                            </button>
                            {showList3 && (
                                <ul>
                                    {""}
                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(4)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList4 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}{" "}
                                Purpose and description of the following components
                            </button>
                            {showList4 && (
                                <ul>
                                    <li> Power supply unit
                                    </li>
                                    <li>CPU-Central Processing unit

                                    </li>
                                    <li>IM-Interface module

                                    </li>
                                    <li>Signal module

                                    </li>
                                    <li>Function module

                                    </li>


                                    <li>Communication Processor


                                    </li>

                                    <li>Wire annotations

                                    </li>

                                    <li>Bus system


                                    </li>

                                    <li>Rack/Rail



                                    </li>
                                </ul>
                            )}
                        </div>
                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Plc Hardware & Architecture {" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li> Wiring Different field Devices to PLC

                                    </li>
                                    <li> Addressing for PLC

                                    </li>

                                </ul>
                            )}
                        </div>


                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Introduction to programming language of Plc {" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Advantages of PLC


                                    </li>
                                    <li> NO/NC concept of PLC.
                                    </li>

                                    <li> Down a load of PLC program

                                    </li>
                                    <li> Up a load of PLC program

                                    </li>
                                    <li> Ladder Programming using different logic gates and Interlocking Concept

                                    </li>

                                </ul>
                            )}
                        </div>


                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Bit logic operation {" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Set and reset Instruction



                                    </li>
                                    <li> SR and RS Instruction

                                    </li>

                                    <li>Positive edge and Negative edge etc


                                    </li>


                                </ul>
                            )}
                        </div>


                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Timers{" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Purpose and type of timers




                                    </li>
                                    <li> Description of each timer


                                    </li>

                                    <li>Programming on each timer



                                    </li>

                                    <li>Programming on Timers with examples




                                    </li>

                                </ul>
                            )}
                        </div>


                        <div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Counters{" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Purpose




                                    </li>
                                    <li> Types of counter



                                    </li>

                                    <li>Description of each counter




                                    </li>

                                    <li>Programming on counters with examples





                                    </li>

                                </ul>
                            )}
                        </div>



<div className="responsive_introduction_container">
                            <button
                                className=" collapsed responsive_introduction_button"
                                data-toggle="collapse"
                                data-target="#collapse__111"
                                aria-expanded="false"
                                aria-controls="collapse__111"
                                onClick={() => toggleList(5)}

                            >
                                {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
                                {showList5 ? (
                                    <i classNameName="fas fa-arrow-up"></i>
                                ) : (
                                    <i
                                        classNameName="fas fa-arrow-down"
                                        style={{ color: "black" }}
                                    ></i>
                                )}
                                Miscellaneous{" "}
                            </button>
                            {showList5 && (
                                <ul>
                                    <li>Compare/Move instruction





                                    </li>
                                    <li> Mathematical instruction




                                    </li>

                                    <li>Logical instruction





                                    </li>

                                    <li>JFIFO/LIFO
                                    </li>
  <li>Formation of function block

                                    </li>
                                    <li>Scaling

                                    </li>
                                    <li>Designing of Automation Program using Star delta starter and troubleshooting in PLC

                                    </li>
                                    
                                </ul>
                            )}
                        </div>















                    </div>
                </div>

                <div className="responsive_courese_image_container">
                    <img
                        src="img/PLC-1.webp"
                        alt="Course Image"
                        className="responsive_course_image" />
                </div>
            </div>

            <div className="contact-us-section-wrappaer ">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7 col-lg-7">
                            <div className="conact-us-wrap-one">
                                <br />
                                <br />
                                <h5 className="heading mb-20">
                                    How will you get your certificate?
                                </h5>
                                <div className="center_details">
                                    {/* <!--   <h5 className="heading mb-20">CERTIFICATE FAQ</h5> --> */}
                                    <p>
                                        Upon successful completion of the program, each intern
                                        receives a prestigious Digital Marketing Internship
                                        Certificate. This credential not only recognizes their
                                        achievements but also enhances their employability.
                                    </p>
                                    <p style={{ textAlign: "justify" }}>
                                        CAD DESK  Kaniyapuram is a pioneer in Mechanical/Civil
                                        training and most of the industries give great recognition
                                        to its certificate throughout India and abroad. CAD DESK
                                         Kaniyapuram Certificates are ISO verified which makes it
                                        highly reputed comparing to the other local brands and helps
                                        the student get prioritize while going for job opportunities
                                        in the industry. CAD DESK  Kaniyapuram Software Training is
                                        conducted by highly knowledgeable trainers which help
                                        students to enhance their skill set by putting great
                                        emphasizes on project-based learning.
                                    </p>
                                    {/* <!-- <a className="btn btn-primary">Get Certificate</a> --> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-lg-5">
                            <div className="contact-form-wrap">
                                {/* <!-- <h5 className="heading mb-20">How will you get your certificate?</h5> --> */}
                                <img
                                    src="img/Certificate.webp"
                                    style={{
                                        width: " 100%",
                                        marginTop: "100px",
                                        height: "370px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
        </Fragment>
    );
};

export default Plc;
